var map = {
	"./attachments/delete.svg": 2385,
	"./attachments/dowload.svg": 2386,
	"./attachments/ellipsis.svg": 2387,
	"./attachments/ellipsisHover.svg": 1042,
	"./attachments/excel.svg": 1043,
	"./attachments/iconListView.svg": 1044,
	"./attachments/iconModuleView.svg": 1045,
	"./attachments/image.svg": 1046,
	"./attachments/others.svg": 1047,
	"./attachments/pdf.svg": 1048,
	"./attachments/view.svg": 2388,
	"./attachments/word.svg": 1049,
	"./bmp.svg": 2389,
	"./doc.svg": 2390,
	"./docx.svg": 2391,
	"./file.svg": 1041,
	"./jpeg.svg": 2392,
	"./jpg.svg": 2393,
	"./pdf.svg": 2394,
	"./png.svg": 2395,
	"./ppt.svg": 2396,
	"./pptx.svg": 2397,
	"./rar.svg": 2398,
	"./xls.svg": 2399,
	"./xlsx.svg": 2400,
	"./zip.svg": 2401
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2384;